import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { WorkOrderAssignmentSubmission } from "../../shared/interfaces/WorkOrder";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useAssignWorkOrder(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["assignWorkOrder"],
    async (workOrderAssignment: WorkOrderAssignmentSubmission) =>
      apiContext.assignmentApis.assignWorkOrder(workOrderAssignment),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
